// The client's mark on the welcome screen, or Nova's until a bundle names one.
//
// THE PAGE PICKS LIGHT OR DARK FROM ITS OWN THEME, not from the file. A visitor
// who flips the theme pill should see the matching file, and a bundle that only
// named one still has a mark to show — the other slot falls back to the one
// that exists, then to Nova's.

import type { ReactNode } from "react";

import type { PageTheme } from "./theme.js";

export type ClientLogos = { readonly light?: string; readonly dark?: string } | null;

export function ClientMark({
  logos,
  theme,
  baseUrl,
  fallback,
}: {
  readonly logos: ClientLogos;
  readonly theme: PageTheme;
  readonly baseUrl: string;
  readonly fallback: ReactNode;
}): ReactNode {
  const src = pickLogo(logos, theme);
  if (src === null) return fallback;
  return <img className="web-client-logo" src={resolveLogo(src, baseUrl)} alt="" />;
}

function pickLogo(logos: ClientLogos, theme: PageTheme): string | null {
  if (logos === null) return null;
  const preferred = theme === "dark" ? logos.dark : logos.light;
  const other = theme === "dark" ? logos.light : logos.dark;
  return preferred ?? other ?? null;
}

function resolveLogo(src: string, baseUrl: string): string {
  const origin = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
  if (origin === "" || !src.startsWith("/v1/kiosk/assets/")) return src;
  return origin + src;
}
